import { scheduleWindows } from '@/mocks/cinema';

const tagStyle: Record<string, string> = {
  重点: 'bg-primary-600 text-background-50',
  国产: 'bg-primary-100 text-primary-700',
  引进: 'bg-accent-100 text-accent-800',
  合家欢: 'bg-secondary-100 text-secondary-800',
};

export default function WindowSection() {
  return (
    <section id="window" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
            <i className="ri-calendar-event-line"></i>
            档期窗口
          </span>
          <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">
            最新档期 · 上映窗口
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            从国庆档到贺岁档，提前锁定每个档期窗口的热门片单，想看的片子一场都不错过。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-5 lg:flex-row">
          <div className="lg:w-1/3">
            <div className="flex h-full flex-col justify-center rounded-lg bg-gradient-to-br from-primary-700 to-primary-900 p-6 text-background-50">
              <p className="text-xs font-medium tracking-widest text-accent-300">档期热度 TOP 影片</p>
              <h3 className="mt-2 font-heading text-3xl font-bold leading-snug md:text-4xl">
                《祖国，生日快乐》
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-background-100/80">
                国庆档最稳种子选手，全明星主创阵容，档期想看热度一路冲高至 9.6，是本届国庆档当之无愧的票房焦点。
              </p>
              <span className="mt-5 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-background-50">
                加入想看名单
                <i className="ri-heart-3-line"></i>
              </span>
            </div>
          </div>

          <div className="grid flex-1 grid-cols-1 gap-4 sm:grid-cols-2">
            {scheduleWindows.map((w) => (
              <div
                key={w.name}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
              >
                <div className="flex items-center justify-between">
                  <span className="font-display text-sm font-bold text-primary-700">{w.period}</span>
                  <span className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${tagStyle[w.tag]}`}>
                    {w.tag}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-500">{w.date}</p>
                <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">{w.name}</h3>
                <p className="mt-1.5 flex-1 text-sm leading-relaxed text-foreground-600">{w.note}</p>
                <div className="mt-3 flex items-center gap-1 text-sm">
                  <i className="ri-fire-fill text-primary-500"></i>
                  <span className="font-display font-bold text-primary-600">{w.hot}</span>
                  <span className="text-xs text-foreground-500">档期热度</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}